/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../../client.ts';
import type {
  UserFlagsModeratorControllerCreateMutationRequest,
  UserFlagsModeratorControllerCreateMutationResponse,
  UserFlagsModeratorControllerCreate401,
} from '../../types/UserFlagsModeratorControllerCreate.ts';
import type { UseMutationOptions, QueryClient } from '@tanstack/react-query';
import { userFlagsModeratorCreate } from '../../methods/userFlagsModeratorCreate.ts';
import { useMutation } from '@tanstack/react-query';

export const userFlagsModeratorCreateMutationKey = () => [{ url: '/api/moderator/user-flags' }] as const;

export type UserFlagsModeratorCreateMutationKey = ReturnType<typeof userFlagsModeratorCreateMutationKey>;

/**
 * {@link /api/moderator/user-flags}
 */
export function useUserFlagsModeratorCreate<TContext>(
  options: {
    mutation?: UseMutationOptions<
      UserFlagsModeratorControllerCreateMutationResponse,
      ResponseErrorConfig<UserFlagsModeratorControllerCreate401>,
      { data: UserFlagsModeratorControllerCreateMutationRequest },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig<UserFlagsModeratorControllerCreateMutationRequest>> & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey = mutationOptions.mutationKey ?? userFlagsModeratorCreateMutationKey();

  return useMutation<
    UserFlagsModeratorControllerCreateMutationResponse,
    ResponseErrorConfig<UserFlagsModeratorControllerCreate401>,
    { data: UserFlagsModeratorControllerCreateMutationRequest },
    TContext
  >(
    {
      mutationFn: async ({ data }) => {
        return userFlagsModeratorCreate(data, config);
      },
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  );
}
